<section class="no-auth-page">
  <header>
    <h3>{{ 'auth.loginTwoFa.title' | translate }}</h3>
    <h4>{{ 'auth.loginTwoFa.subtitle' | translate }}</h4>
  </header>

  <form
    [formGroup]="form"
    class="ht-form ht-form--auth"
    (ngSubmit)="onSubmit()"
  >
    <div class="ht-form-item">
      <div class="ht-form-item-title">
        {{ 'auth.loginTwoFa.code' | translate }}
      </div>
      <div class="ht-form-item-control">
        <ht-input
          [label]="'auth.loginTwoFa.code' | translate"
          formControlName="code"
          fullWidth="true"
          [helpText]="'auth.loginTwoFa.codeHelpText' | translate"
        ></ht-input>
      </div>
    </div>

    <div class="feedback-wrapper">
      @if (error()) {
        <div class="error-alert">
          <i class="fa-solid fa-circle-xmark"></i>
          <span>{{ error() }}</span>
        </div>
      }

      <button
        ht-button-primary
        type="submit"
        size="large"
        [isLoading]="isLoading()"
        [isDisabled]="form.invalid"
        fullWidth="true"
      >
        {{ 'auth.loginTwoFa.verify' | translate }}
      </button>

      <button
        ht-button-secondary
        size="large"
        [isDisabled]="isLoading()"
        fullWidth="true"
        (click)="onCancel()"
      >
        {{ 'common.cancel' | translate }}
      </button>
    </div>
  </form>
</section>
